<template>
  <div class="bless-page">
    <div class="bless-wrapper" v-if="isShowBlessPage">
      <div class="top-bg">
        <img :src="isOpened ? topImage2:topImage1">
      </div>
      <div class="bless-content">
        <!-- 气泡 -->
        <div class="bubble-wrapper" v-if="bubbleList.length > 0 && !isOpened">
          <bubble :bubbleList="bubbleList" v-if="showBubble"></bubble>
        </div>
        <!-- 头像 -->
        <avatar ref="avatar" class="avatar-box"></avatar>
        <!-- 福袋 -->
        <bless-package :hasPhone="hasPhone" :needLogin="needLogin" @openBlessPackage="openBlessPackage" :bagBasicInfor="bagBasicInfor"></bless-package>
      </div>  
      <div class="rule-btn" @click="openRule">
        <div class="rule-btn-bg"></div>
        <p>规则</p>
      </div>  
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui'
import { mapGetters } from 'vuex'
import { getBubbleRelation, getBagBasicInfor } from '../api/home'
import bubble from './bubble'
import avatar from './avatar'
import blessPackage from './blessPackage'
import topBg1 from '../images/yj_recall_bg_top1.png'
import topBg2 from '../images/yj_recall_bg_top2.png'
import bottomBg from '../images/yj_recall_bg_bottom.png'
import blessPack from '../images/yj_recall_fu.png'
import openNow from '../images/yj_open_now.png'
import toSee from '../images/yj_app_to_see.png'
import openingImage from '../images/yj_bless_opening.png'
import noRewardImage from '../images/yj_no_reward_icon.png'
import scoreBg from '../images/yj_score_bg.png'

const MARQUEE_SHOW_WAY_TYPE = {
  /**
   * 关闭
   */
  CLOSE: 0,
  /**
   * 打开
   */
  OPEN: 1
}
export default {
  name: 'blessPage',
  data() {
    return {
      isShowBlessPage: false,
      imageCount: 0,
      isOpened: false,
      topImage1: topBg1,
      topImage2: topBg2,
      rewardCoupon: '//static.yunjiglobal.com/recall/yj_reward_coupon.png',
      bubbleList: [],
      // 福袋基本配置信息
      bagBasicInfor: {}
    }
  },
  props: {
    hasPhone: {
      type: Boolean,
      default: false 
    },
    needLogin: {
      type: Boolean,
      default: false 
    }
  },
  components: {
    bubble,
    avatar,
    blessPackage
  },
  watch: {
    'bagBasicInfor.shareTitle'() {
      this.initWxshareConfig({
        subContent: this.bagBasicInfor.shareText,
        mainContent: this.bagBasicInfor.shareTitle,
        icon: this.bagBasicInfor.shareImage
      })
    }
  },
  computed: {
    ...mapGetters(['appCont', 'shopId', 'isFromHeJi', 'activityId', 'luckBagCode', 'smsId']),
    /**
     * 是否显示轮播
     */
    showBubble() {
      return this.bagBasicInfor && (this.bagBasicInfor.marqueeShowWay === MARQUEE_SHOW_WAY_TYPE.OPEN)
    }
  },
  mounted() {
    this.preloadImages()
    this.getBagBasicInforFunc()
  },
  methods: {
    initWxshareConfig(params) {
      let linkUrl = params.url || window.location.href
      if (linkUrl.indexOf('appCont') < 0) {
        linkUrl = `${linkUrl}&appCont=0`
      }
      this.wxShare({
        content: params.subContent || '一万人已拆出5元无门槛，我看你也行',
        link: linkUrl,
        imgUrl:
          params.icon
          || 'https://static.yunjiglobal.com/qnUpload/frontend/membercenter/recallShare.png',
        title: params.mainContent || '送你一个福袋，看看能拆出啥~',
        callback: () => {
          // 分享成功回调
        },
        configDone: (data, res) => {
          // console.error(data)
        }
      })
    },
    /**
     * 打开规则页面
     */
    openRule() {
      thinkingReport.track('others', {
        point_id: '27314',
        page_id: '80740',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      const subjectId = this.bagBasicInfor && this.bagBasicInfor.ruleContent
      window.location.href = `//${globalConfig.yunjibuyerPath}/yj/subject?subjectId=${subjectId}&shopId=${this.shopId}&appCont=${this.appCont}`
    },
    /**
     * 获取福袋配置
     */
    getBagBasicInforFunc() {
      getBagBasicInfor({
        code: this.luckBagCode
      }).then((res) => {
        if (res.code == 0) {
          this.bagBasicInfor = res.data || {}
        }
      }, () => {

      })
    },
    // 打开了福袋
    openBlessPackage() {
      this.isOpened = true
      this.$refs.avatar.animate = true
    },
    preloadImages() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      const loadingImgs = [
        topBg1,
        topBg2,
        bottomBg,
        blessPack,
        openNow,
        toSee,
        openingImage,
        noRewardImage,
        scoreBg,
        this.rewardCoupon
      ]
      const imgWrap = []
      const that = this
      for (let i = 0; i < loadingImgs.length; i += 1) {
        imgWrap[i] = new Image()
        imgWrap[i].src = loadingImgs[i]
        imgWrap[i].onload = function onloadImage() {
          that.imageCount += 1
          if (that.imageCount === loadingImgs.length) {
            that.showBlessPack()
          }
        }
      }
    },
    showBlessPack() {
      Indicator.close()
      this.isShowBlessPage = true
      this.getBubbles()
    },
    // 获取气泡
    getBubbles() {
      getBubbleRelation({
        appCont: this.appCont
      }).then((res) => {
        if (res.code === 0 || res.errorCode === 0) {
          this.bubbleList = res.data || []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.bless-page {
  width: 100%;  
  min-height: 100vh;
  background-image: linear-gradient(180deg, #FFE6E6, #FF6478 20%, #FF444E 30%, #FF444E 70%);
  .bless-wrapper {
    width: 100%;
    padding-top: 0.4rem;
    position: relative;
    .top-bg {
      top: 0;
      left: 0;
      width: 100%;
      position: absolute;
      z-index: 0;
      img {
        display: block;
        width: 100%;
      }
    }
    .bless-content {   
      position: relative;
      z-index: 1;  
      width: 100%;
      .bubble-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;       
      }
      .bubble-wrapper ~ .avatar-box{
        margin-top: 0.36rem;
      }
    }    
    .rule-btn{
      position: absolute;
      z-index: 100;
      top: 0.2rem;
      right: 0;
      width: 1.2rem;
      height: 0.56rem;
      font-size: 0.28rem;
      color:  #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 0.56rem;
      .rule-btn-bg{
        width: 100%;
        height: 100%;
        opacity: 0.1;
        background: #000000;
        border-radius: 1rem 0 0 1rem;
        position: absolute;
      }
    }
  }
.topBg-enter {
  opacity: 0;
}
.topBg-enter-to {
  opacity: 1;
}
.topBg-enter-active {
  transition: all 0.5s;
}
}
</style>
